import { memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { formatDuration } from '@air/utilities';
import { ClipUtils, isPdfRenderedExtension } from '@air/utils-clips';

export type AssetGalleryCardShortInfoProps = {
  clip: Clip | PublicClip;
};

const PDF_LETTER_SPACING = 1.44;
const VIDEO_LETTER_SPACING = 0.32;

export const AssetGalleryCardShortInfo = memo(({ clip }: AssetGalleryCardShortInfoProps) => {
  const time = formatDuration(clip.duration ?? 0);
  const transcoded = ClipUtils.isTranscoded(clip.status);
  const videoTime = clip.type === 'video' && transcoded && time;

  const value = isPdfRenderedExtension(clip.ext) ? clip.ext.toUpperCase() : videoTime;

  if (!value) {
    return null;
  }

  return (
    <span
      className="flex h-4 items-center rounded-2 bg-pigeon-700 px-1 font-medium text-10 text-white"
      style={{
        letterSpacing: isPdfRenderedExtension(clip.ext) ? PDF_LETTER_SPACING : VIDEO_LETTER_SPACING,
        fontWeight: isPdfRenderedExtension(clip.ext) ? 'semibold' : 'medium',
      }}
    >
      {value}
    </span>
  );
});

AssetGalleryCardShortInfo.displayName = 'AssetGalleryCardShortInfo';
